import cn from 'classnames';
import utilityClasses from '../scss/utilities.module.scss';

// turns props from components into classnames from utilities.module.scss
// utilities classes can be overridden in a component's styles, which take precedent over anything in utilities
// this way we can have styles reusable props across all components that don't need to be defined everywhere,
const applyClasses = (props = [], classes = {}) => {
  const allClasses = { ...utilityClasses, ...classes };
  return cn(
    Object.entries(props).map(
      ([propName, value]) => value && allClasses[propName]
    )
  );
};

export default applyClasses;
